import src from "IMAGE";
export default { src, width: 2500, height: 365, blurWidth: 0, blurHeight: 0};
